import { DsButtonKind, DsButtonSize, DsButtonVariant } from '@frontend/ui/button';

import { IDialogTracking } from './modal-dialog.model';

export interface IConfirmationDialogComponentModel {
    message: string;
    buttons: IConfirmationDialogButton[];
    tracking?: IDialogTracking;
    icon?: string;
    cssClass?: string;
}

export interface IConfirmationDialogModel extends IConfirmationDialogComponentModel {
    title: string;
    backdropClass?: string;
}

export interface IConfirmationDialogButton {
    buttonType: ConfirmationDialogButtonType;
    buttonOrderClass?: string;
    buttonTitle: string;
    buttonConfig?: {
        kind: DsButtonKind;
        variant: DsButtonVariant;
        size: DsButtonSize;
    };
    cssClass?: string;
}

export enum ConfirmationDialogButtonType {
    Ok = 'Ok',
    Cancel = 'Cancel',
}

export interface IConfirmationDialogInput {
    contentModel: IConfirmationDialogModel;
}
